<template>
  <nav class="nav">
      <ul>
        <router-link tag="li" to="/bookings"><a>Bookings</a></router-link>
        <router-link tag="li" to="/customers"><a>Customers</a></router-link>
        <router-link tag="li" to="/agents"><a>Agents</a></router-link>
        <router-link tag="li" to="/suppliers"><a>Suppliers</a></router-link>
        <router-link tag="li" to="/resorts"><a>Resorts</a></router-link>
        <router-link tag="li" to="/affiliates"><a>Affiliates</a></router-link>
        <router-link tag="li" :to="{name:'summary-index'}"><a>Summaries</a></router-link>
        <router-link tag="li" to="/tours"><a>Tours</a></router-link>
        <router-link tag="li" to="/flights"><a>Flights</a></router-link>
        <router-link tag="li" to="/airlines"><a>Airlines</a></router-link>
        <router-link tag="li" to="/accommodation"><a>Accommodation</a></router-link>
        <router-link tag="li" to="/brochure-requests"><a>Brochure Requests</a></router-link>
        <router-link tag="li" to="/discounts"><a>Discounts</a></router-link>
        <router-link tag="li" to="/extras"><a>Extras</a></router-link>
        <router-link tag="li" to="/reports"><a>Reports</a></router-link>
        <router-link tag="li" to="/cancellations"><a>Cancellations</a></router-link>
        <router-link tag="li" to="/templates"><a>Dynamic templates</a></router-link>
        <router-link tag="li" :to="{name:'service-types'}"><a>Service Type</a></router-link>
        <router-link tag="li" to="/tour-manager"><a>Tour Managers</a></router-link>
        <router-link tag="li" :to="{name:'advertise-sizes'}"><a>Advertise Sizes</a></router-link>
      </ul>
    </nav>
</template>

<script>
export default {
  name: 'Nav',
  computed: {
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  data() {
    return {
      showSubMenu: false,
    };
  },
  created () {
      console.log(this.$authtoken);
  },
  methods: {
    toggleSubMenu() {
      this.showSubMenu = !this.showSubMenu;
    },
  }
}
</script>
